import { LOGIN_ERROR, LOGIN_POST_ERROR, LOGIN_SUCCESS } from "../actions/types";

export default (state = { error: "" }, action) => {
    console.log(action.type)
  switch (action.type) {
      case LOGIN_ERROR:
          return {
              error: action.payload,
              loading: false,
              key: action.key,
              isSnackbarError: true,
              isSwitchSnackbarOn: true,
              ErrorMessage: 'Login fail. Please check your username and password.',
          };
          break;
          
      case LOGIN_SUCCESS:
        return {
            error: false,
            loading: false,
            key: action.key,
            isSnackbarError: true,
            isSwitchSnackbarOn: true,
            ErrorMessage: 'Login Success',
        };
        break;
      case LOGIN_POST_ERROR:
          return {
              loading: false,
              key: action.key,
              isSnackbarError: true,
              isSwitchSnackbarOn: true,
              ErrorMessage: action.error + '. Please contact administrator.',
              error: true,
          };
          break;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js